import { render, staticRenderFns } from "./un-sga.vue?vue&type=template&id=376d4e9d&scoped=true"
import script from "./un-sga.vue?vue&type=script&lang=js"
export * from "./un-sga.vue?vue&type=script&lang=js"
import style0 from "./un-sga.vue?vue&type=style&index=0&id=376d4e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376d4e9d",
  null
  
)

export default component.exports